import React              from 'react';
import { useTranslation } from 'react-i18next';
import TextField          from '@material-ui/core/TextField';
import PropTypes          from 'prop-types';

const OSBetaSelector = ({ value, setValue, disabled = false, required = false, ...rest }) => {
	const { t } = useTranslation();

	return (
		<TextField
			label={t('custom_os_beta_label')}
			helperText={t('custom_os_beta_helperText')}
			value={value}
			onChange={e => setValue(e.target.value)}
			select
			fullWidth
			InputLabelProps={{ shrink: !!value }}
			disabled={disabled}
			required={required}
			variant='outlined'
			SelectProps={{
				native: true
			}}
			{...rest}
		>
			<option value='Y'>{t('custom_os_beta_y')}</option>
			<option value='N'>{t('custom_os_beta_n')}</option>
		</TextField>
	);
};

export default OSBetaSelector;

OSBetaSelector.propTypes = {
	disabled: PropTypes.bool,
	required: PropTypes.bool,
	setValue: PropTypes.func.isRequired,
	value: PropTypes.string
};
